import { CreditsState } from './creditsTypes';
import { CREDITS_NAMESPACE } from './creditsReducer';
import { useAppAction, useAppSelector } from '../hooks';
import { setCreditInUseAction, FetchUserCreditsThunk } from './creditsActions';

export function useCreditsSelector<T extends (state: CreditsState) => any>(
  selector: T
): ReturnType<T> {
  return useAppSelector((state) => selector(state[CREDITS_NAMESPACE]));
}

export const useCredits = () =>
  useCreditsSelector((state) => {
    return state.credits;
  });

export const useCreditInUse = () =>
  useCreditsSelector((state) => {
    return state.creditInUse;
  });

export const useSetCreditInUse = () => useAppAction(setCreditInUseAction);
export const useFetchCredits = () => useAppAction(FetchUserCreditsThunk);
